export default "__VITE_ASSET__BNGE81Fg__"